'use strict';

module.exports = function subscriptionRenewalDateDescription(subscription) {
	const expiryTs = subscription && subscription.expiry,
		expiryDate = expiryTs && new Date(expiryTs * 1000);
	return (expiryDate && expiryDate.toDateString()) || '';
};
